import RoutingView from './routing_view';

export default RoutingView;
